<template>
  <div class="core_wrap" v-if="hotProductList.length > 0">
    <div class="core_title">Hot Products</div>

    <!-- 动态切换按钮 -->
    <div class="core_options_wrap">
      <el-row class="core_options" type="flex" justify="flex-start">
        <el-col
            class="core_items"
            v-for="(item, index) in hotProductList"
            :key="item.id"
            :class="currentIndex === index ? 'is_active' : ''"
            @click.native="changeCurrentIndex(index)"
        >
          <!-- 图标 + 文字，index%3 循环切换图片 -->
          <img
              :src="require(`@/assets/class${(index % 3) + 1}.png`)"
              alt=""
              class="item-icon"
          >
          <span class="item-label">{{ item.label }}</span>
        </el-col>
      </el-row>
    </div>

    <!-- 动态展示对应产品 -->
    <component
        :is="currentComponent"
        :core="hotProductList[currentIndex]"
        :productNo="hotProductList[currentIndex].productNo"
        :key="currentIndex"
    />
  </div>
</template>

<script>
import CoreItemOne from './CoreItemOne.vue'
import { getHotProductList } from '../../api/system';

export default {
  data() {
    return {
      hotProductList: [],
      currentIndex: 0,
      currentComponent: CoreItemOne,
      hidden: true
    }
  },
  methods: {
    changeCurrentIndex(index) {
      this.currentIndex = index
    },

    async loadHotProducts() {
      try {
        const res = await getHotProductList()
        if (res.data.code === 200) {
          this.hotProductList = res.data.data || []
        }

        if (this.hotProductList.length > 0) {
          this.currentIndex = 0
        }
      } catch (err) {
        console.error('加载热门产品失败', err)
      }
    }
  },
  mounted() {
    this.loadHotProducts()
  }
}
</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;

  .core_title {
    color: #880f53;
    font-size: 46px;
    font-weight: bold;
    padding: 30px 0;
    font-family: 'Roboto_Bold', sans-serif;
    @media screen and (max-width: 768px) {
      font-size: 2rem;
    }
  }

  // 滚动外层容器
  .core_options_wrap {
    width: 70%;
    margin: 0 auto;
    overflow-x: auto;
    overflow-y: hidden;

    // 显示自定义滚动条
    scrollbar-width: 6px;
    scrollbar-color: #880f53 #eee;
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #eee;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #880f53;
      border-radius: 3px;
    }

    @media screen and (max-width: 768px) {
      width: 90%;
    }
  }

  .core_options {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;

    .core_items {
      /* PC端一行3个 */
      width: calc((100% - 40px) / 5);
      flex-shrink: 0;
      height: 80px;
      border: solid 1px #c3c5c5;
      font-size: 25px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 8px;
      color: #000000;
      font-family: 'Roboto_Bold', sans-serif;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .item-icon {
        width: 45px;
        height: 45px;
        object-fit: contain;
      }

      .item-label {
        line-height: 1;
      }

      /* 移动端一行最多2个 */
      @media screen and (max-width: 768px) {
        width: calc((100% - 7px) / 3);
        height: 50px;
        font-size: 16px;

        .item-icon {
          width: 24px;
          height: 24px;
        }
      }
    }

    .is_active {
      color: #fff;
      font-weight: bold;
      background: #880f53;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(21, 21, 21, 0.5);
    }
  }
}
</style>